// src/utils/podcastOrder.js
//
// Manual ordering for the Performance 1-2-3 podcast library. Episodes with a
// numeric `order` (set by drag-and-drop in the Content Library) come first,
// ascending; anything without one falls back to newest-first. Shared by the
// player (Performance123View) and the CMS list so both agree on the sequence.

export const sortEpisodes = (items) =>
    [...items].sort((a, b) => {
        const ao = typeof a.order === 'number' ? a.order : Infinity;
        const bo = typeof b.order === 'number' ? b.order : Infinity;
        if (ao !== bo) return ao - bo;
        return String(b.createdAt || '').localeCompare(String(a.createdAt || ''));
    });
